const landing_page = {
  aboutUs: "Tentang Kami", // translated 
  topPackages: "Pakej Terbaik", // translated 
  featuredHotels: "Hotel Pilihan", // translated 
  topTours: "Lawatan Teratas", // translated 
  whatOurMembersSay: "Apa kata ahli kami...", // translated 
  followUsOnInstagram: "Ikuti kami di Instagram", // translated 
  pleaseWait: "Sila tunggu...", // translated 
  packages: "Pakej", // translated 
  ourPartners: "Rakan Kongsi Kami", // translated 
  trustedCarHirePartners: "Rakan Sewa Kereta yang Dipercayai", // translated 
  learnMore: "Ketahui Lebih Lanjut", // translated 
};






export default landing_page;
